import axios from "axios";
import { Manager } from "socket.io-client";
const token = localStorage.getItem("token");
const url = "http://localhost:5000";
const instance = axios.create({
  baseURL: url,
});
const manager = new Manager(url, {
  autoConnect: false,
  query: { token },
});
export const socket = manager.socket("/");
export default instance;
